import React from 'react';
import classNames from 'classnames';
import {Radio as SemanticUiRadio} from 'semantic-ui-react';

import {Props} from './types';
import * as handlers from './handlers';

import './index.scss';

const Radio: React.FC<Props> = props => {
  return (
    <SemanticUiRadio
      name={props.field.name}
      className={classNames('a__form-radio', {
        'is_read-only': props.readOnly,
      })}
      checked={props.value === props.field.value}
      onChange={(event: any, data: any) =>
        handlers.onChange(data, props.form, props.field.name)
      }
      value={props.value}
      {...props}
    />
  );
};

export default Radio;
